import { computed as c, createElementBlock as n, openBlock as m, normalizeClass as i, createElementVNode as s, toDisplayString as o } from "vue";
import { themeProp as p } from "../../../../composables/useTheme.js";
/* empty css                 */
import l from "../../../../_virtual/_plugin-vue_export-helper.js";
const u = {
  class: "ds-metric-card__text ds-text",
  "data-j-description": ""
}, g = /* @__PURE__ */ Object.assign({
  name: "DsMetricCard"
}, {
  __name: "metric-card",
  props: {
    metric: {
      type: String,
      required: !0
    },
    description: {
      type: String,
      required: !0
    },
    ...p
  },
  setup(d) {
    const t = d, r = c(() => {
      const e = String(t.metric.toString().slice(0, 60));
      return {
        metric: e,
        isLargeText: e.length < 7
      };
    }), a = c(() => String(t.description.toString().slice(0, 120)));
    return (e, _) => (m(), n("div", {
      class: i([`ds-metric-card--${e.theme}`, "ds-metric-card ds-padding-24 ds-display-flex ds-flex-direction-column ds-justify-content-space-between"])
    }, [
      s("h4", {
        class: i([r.value.isLargeText ? "ds-heading-xlarge" : "ds-text-xlarge", "ds-metric-card__title ds-color-green"]),
        "data-j-metric": ""
      }, o(r.value.metric), 3),
      s("p", u, o(a.value), 1)
    ], 2));
  }
}), v = /* @__PURE__ */ l(g, [["__scopeId", "data-v-2506e769"]]);
export {
  v as default
};
